<template>
  <div class="stlc_icon_list_container stlc_social_networks">
    <template v-for="(snItem, index) in socialNetworkLinks">
      <a
        v-if="snItem?.SocialNetwork?.ShowInList"
        :key="'sn_' + index"
        :href="snItem.Url"
        :title="snItem.SocialNetwork.Name"
        class="stlc_list_icon_item"
        target="_blank"
        @click="
          dataLayerTagging(socialInteractionTags, storeName, snItem.SocialNetwork.Name, snItem.Url)
        "
      >
        <img
          v-if="snItem.SocialNetwork.LinkIconUrl"
          :alt="snItem.SocialNetwork.Name"
          :src="snItem.SocialNetwork.LinkIconUrl"
          class="stlc-store-list-icons"
        />
        <span v-if="snItem.SocialNetwork.LinkText">
          {{ snItem.SocialNetwork.LinkText }}
        </span>
      </a>
      <span v-if="socialIconsLineBreaks" :key="index" class="stlc_break_line"></span>
    </template>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { tryParseJson } from '../mixins/utils';

export default {
  name: 'rfp-storelocator-social-links',
  props: {
    socialNetworkLinks: {
      type: Array,
      required: true,
    },
    socialInteractionTags: {
      type: String,
      required: false,
      default: '',
    },
    storeName: {
      type: String,
      required: true,
    },
  },
  computed: {
    socialIconsLineBreaks() {
      if (this.socialNetworkLinks && this.socialNetworkLinks.length) {
        return this.socialNetworkLinks.some((l) => l.SocialNetwork.LinkText);
      }

      return false;
    },
  },
  methods: {
    dataLayerTagging(tags, storeName, socialNetwork, socialTarget) {
      if (!tags) return false;
      eventBus.emit('rfpTaggingPushToDatalayer', {
        tags: tryParseJson(tags),
        values: {
          storeName: storeName,
          socialNetwork: socialNetwork,
          socialTarget: socialTarget,
        },
      });
    },
  },
};
</script>
